import type { RouteProps } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { useAuthenticateApplication } from '@/new_src/application/Auth/Authenticate';
import { useAuthService } from '@/new_src/service/inbound/Auth/adapter';

import { selectConnectOption } from 'modules/connect';
import { paths, routerSelector } from 'modules/router';
import { selectCurrentUserId, sessionSelectors } from 'modules/session/selectors';

const RouteWithoutAuth = ({ children, ...rest }: RouteProps & { children?: React.ReactNode }) => {
  const isLoggedIn = useSelector(sessionSelectors.isLoggedIn);
  const connectOption = useSelector(selectConnectOption);
  const previousPath = useSelector(routerSelector.previousPath);
  const previousPathUserId = useSelector(routerSelector.previousPathUserId);
  const currentUserId = useSelector(selectCurrentUserId);
  const AuthService = useAuthService();
  const Authenticate = useAuthenticateApplication();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // 로그인된 상태에서 SSO 로그인 요청이 들어온 경우, SSO로 로그인을 시도하기 위해 로그아웃 처리한다
        if (isLoggedIn && AuthService.isSSOLoginRequest()) {
          Authenticate.handleSignOut();
          return;
        }

        if (!isLoggedIn) {
          return children;
        }

        let nextPath: string = paths.root;

        if (connectOption) {
          // Slack 연동중인 경우 로그인 이 후 다시 연동 flow로 돌아간다
          nextPath = paths.connect;
        } else if (previousPath && previousPathUserId === currentUserId) {
          // 이전 path가 존재하는 경우 이전 path로 redirect
          nextPath = previousPath;
        }

        return (
          <Redirect
            to={{
              pathname: nextPath,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default RouteWithoutAuth;
